export const PERMS = ["can_view", "can_add", "can_edit", "can_delete", "can_change_status", "can_manage_permissions", "can_manage_users"];

export const money = (n, c) => `${Number(n || 0).toLocaleString()} ${c || ""}`.trim();
export const day = (s) => (s ? String(s).slice(0, 10) : "-");
export const isExpired = (s) => s && new Date(String(s).replace(" ", "T")) < new Date();
export const clip = (v, n = 60) => {
  const t = v == null || v === "" ? "-" : String(v);
  return t.length > n ? <span title={t}>{t.slice(0, n)}...</span> : t;
};
export const bytes = (n) => {
  if (n == null) return "-";
  let v = Number(n), i = 0;
  while (v >= 1024 && i < 4) { v /= 1024; i++; }
  return `${v.toFixed(i ? 1 : 0)} ${["B", "KB", "MB", "GB", "TB"][i]}`;
};
export const subTag = (s) =>
  s.status !== 1 ? <span className="tag bad">cancelled</span>
    : isExpired(s.endDate) ? <span className="tag wait">expired</span>
    : <span className="tag">active</span>;

export function csv(name, rows) {
  if (!rows?.length) return;
  const h = Object.keys(rows[0]);
  const t = [h, ...rows.map((r) => h.map((k) => `"${String(r[k] ?? "").replace(/"/g, '""')}"`))]
    .map((r) => r.join(",")).join("\n");
  const a = document.createElement("a");
  a.href = URL.createObjectURL(new Blob([t], { type: "text/csv" }));
  a.download = name + ".csv";
  a.click();
  URL.revokeObjectURL(a.href);
}

export function Wait({ d, children }) {
  if (!d) return <div style={{ padding: 14 }}>Loading...</div>;
  if (d.error) return <div className="err">{d.error}</div>;
  return children;
}

export function Modal({ title, onClose, children, wide }) {
  return (
    <div className="modal" onClick={onClose}>
      <div className={"pane" + (wide ? " wide" : "")} onClick={(e) => e.stopPropagation()}>
        <div className="row" style={{ border: 0 }}>
          <h2 style={{ margin: 0 }}>{title}</h2>
          <button className="btn g s" onClick={onClose}>Close</button>
        </div>
        {children}
      </div>
    </div>
  );
}

export function F({ label, v, set, ...p }) {
  return (
    <>
      <label>{label}</label>
      <input value={v ?? ""} onChange={(e) => set(e.target.value)} {...p} />
    </>
  );
}

// onRowClick is optional. When set, the row is clickable (e.g. to open a details
// or edit modal) — a click that lands on an interactive element inside the row
// (a button, a status <select>, a link) is ignored so it doesn't double-fire
// along with that element's own handler.
const INTERACTIVE = "button, a, select, input, textarea, label";

export function Tbl({ cols, rows, empty = "Nothing here yet.", onRowClick }) {
  return (
    <div className="box">
      <table>
        <thead><tr>{cols.map((c) => <th key={c[0]}>{c[0]}</th>)}</tr></thead>
        <tbody>
          {rows.length === 0 && <tr><td colSpan={cols.length}>{empty}</td></tr>}
          {rows.map((r, i) => (
            <tr
              key={r.id ?? i}
              className={onRowClick ? "clickable" : undefined}
              onClick={onRowClick ? (e) => { if (!e.target.closest(INTERACTIVE)) onRowClick(r); } : undefined}
            >
              {cols.map((c) => <td key={c[0]}>{c[1](r)}</td>)}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export function Pager({ f, setF, d }) {
  return (
    <div className="bar">
      <button className="btn g s" disabled={f.page <= 1} onClick={() => setF({ ...f, page: f.page - 1 })}>Previous</button>
      <span>Page {f.page} of {Math.max(1, Math.ceil(d.total / d.per))} ({d.total} records)</span>
      <button className="btn g s" disabled={f.page * d.per >= d.total} onClick={() => setF({ ...f, page: f.page + 1 })}>Next</button>
    </div>
  );
}

export function Filters({ f, setF, children }) {
  const set = (k, v) => setF({ ...f, [k]: v, page: 1 });
  return (
    <div className="bar">
      <input placeholder="Search" value={f.search} onChange={(e) => set("search", e.target.value)} />
      <input type="date" title="From" value={f.from} onChange={(e) => set("from", e.target.value)} />
      <input type="date" title="To" value={f.to} onChange={(e) => set("to", e.target.value)} />
      {children}
    </div>
  );
}
